// extracted by mini-css-extract-plugin
var _1 = "safeWebsiteSection-module__safeWebsiteSection___C1ewX";
export { _1 as "safeWebsiteSection" }
